import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
const VARIANT = {
    primary: 'bg-arshe-500 text-white hover:bg-arshe-600 focus:ring-arshe-500/40',
    secondary: 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700',
    danger: 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500/40',
    ghost: 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800',
};
const SIZE = {
    sm: 'px-2.5 py-1 text-xs',
    md: 'px-3.5 py-2 text-sm',
    lg: 'px-5 py-2.5 text-base',
};
export const Button = forwardRef(function Button({ variant = 'primary', size = 'md', loading, className, children, disabled, ...rest }, ref) {
    return (_jsxs("button", { ref: ref, disabled: disabled || loading, className: clsx('inline-flex items-center justify-center gap-1.5 rounded-lg font-medium transition focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50', VARIANT[variant], SIZE[size], className), ...rest, children: [loading && _jsx("span", { className: "h-3 w-3 animate-spin rounded-full border-2 border-current border-t-transparent", "aria-hidden": true }), children] }));
});
